import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Menu from "@/pages/Menu";
import Tentang from "@/pages/Tentang";
import Lokasi from "@/pages/Lokasi";
import Kontak from "@/pages/Kontak";
import Faq from "@/pages/Faq";
import NotFound from "@/pages/NotFound";
import { routesMeta, notFoundMeta } from "@/seo/routes";

const RouteEffects = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    const meta = routesMeta.find((r) => r.path === pathname);
    document.title = meta ? meta.title : notFoundMeta.title;
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="flex min-h-screen flex-col">
      <RouteEffects />
      <Header />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu/" element={<Menu />} />
          <Route path="/tentang/" element={<Tentang />} />
          <Route path="/lokasi/" element={<Lokasi />} />
          <Route path="/kontak/" element={<Kontak />} />
          <Route path="/faq/" element={<Faq />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
    </div>
  );
}

export default App;
